import React from 'react'

const Message = () => (
    <p>Agrega una cantidad y plazo a pagar para cotizar tu préstamo.</p>
)


export default Message